import React from 'react';
import { useHistory } from 'react-router-dom';
import './index.less';
import PageLayout from '../../Components/pageLayout';

const certificates = [
    { src: '/pdfs/登记证书正面.jpg', alt: '登记证书正面' },
    { src: '/pdfs/登记证书反面.jpg', alt: '登记证书反面' }
];

const Certificates: React.FC = () => {
    const history = useHistory();
    const [previewImage, setPreviewImage] = React.useState<string | null>(null);

    return (
        <PageLayout history={history} children={[]} Content={
            <div className='page-container'>
                <h1 className='page-title'>证照</h1>
                <p className='certificates-tip'>展示缩略图，点击可查看大图预览。</p>
                <div className='certificates-images'>
                    {certificates.map((item) => (
                        <button
                            key={item.src}
                            type='button'
                            className='cert-card'
                            onClick={() => setPreviewImage(item.src)}
                            aria-label={`预览${item.alt}`}
                        >
                            <img src={item.src} alt={item.alt} loading='lazy' />
                            <span className='cert-card__label'>{item.alt}</span>
                        </button>
                    ))}
                </div>

                {previewImage && (
                    <div className='cert-preview-mask' onClick={() => setPreviewImage(null)}>
                        <button
                            type='button'
                            className='cert-preview-close'
                            onClick={() => setPreviewImage(null)}
                            aria-label='关闭预览'
                        >
                            ×
                        </button>
                        <img
                            className='cert-preview-image'
                            src={previewImage}
                            alt='证照预览'
                            onClick={(e) => e.stopPropagation()}
                        />
                    </div>
                )}
            </div>
        } />
    );
};

export default Certificates;
